const messages = {
    promoBannerHeader: 'AWS Learning Assistant is here!',
    promoBannerMessage: 'Use our AI-powered learning assistant to guide you through AWS concepts and services, troubleshoot lab steps when needed, and explain code as you work through the lab.',
};

export { messages as default };
